import React from 'react';
import { Card } from './ui/card';
import * as Icons from 'lucide-react';
import { industriesData } from '../data/mock';

const Industries = () => {
  return (
    <section id="industries" className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={industriesData.image}
          alt="Industries we serve"
          className="w-full h-full object-cover opacity-5"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              {industriesData.title}
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {industriesData.subtitle}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {industriesData.industries.map((industry, index) => {
              const Icon = Icons[industry.icon];
              return (
                <Card
                  key={index}
                  className="p-6 hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 bg-white"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                      {Icon && <Icon className="w-8 h-8 text-white" />}
                    </div>
                    <h3 className="text-base font-bold text-[#1e3a5f] mb-2">
                      {industry.name}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {industry.description}
                    </p>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
